export const ADD_ALERT = 'APP/ADD_ALERT';
export const REMOVE_ALERT = 'APP/REMOVE_ALERT';